module.exports = __webpack_public_path__ + "static/img/gdzjtjzs.8ec3b4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/01-shouye/gdzjtjzs.jpg
// module id = zJ2W
// module chunks = 1